
import { Node } from '@xyflow/react';
import { Edge } from '@xyflow/react';
import { NodeData } from './initial-nodes';
import { NodePropertiesPanel } from './NodePropertiesPanel';
import { EdgePropertiesPanel } from './EdgePropertiesPanel';
import { GroupPropertiesPanel } from './GroupPropertiesPanel';
import { TextPropertiesPanel } from './TextPropertiesPanel';
import { ActorPropertiesPanel } from './ActorPropertiesPanel';

interface DiagramPropertiesPanelsProps {
  selectedNode: Node<NodeData> | null;
  closePropertiesPanel: () => void;
  saveNodeProperties: (nodeId: string, title: string, selectedComponentId: string, selectedComponentName: string, selectedOrganizationId: string, selectedOrganizationName: string, codeChanges7Days?: number, codeChanges30Days?: number, deploys7Days?: number) => void;
  selectedEdge: Edge | null;
  closeEdgePropertiesPanel: () => void;
  saveEdgeProperties: (edgeId: string, type: string, label: string, markerStart: boolean, markerEnd: boolean, color: string, lineStyle: string) => void;
  selectedGroup: Node<NodeData> | null;
  closeGroupPropertiesPanel: () => void;
  saveGroupProperties: (nodeId: string, title: string, backgroundColor?: string) => void;
  selectedText: Node<NodeData> | null;
  closeTextPropertiesPanel: () => void;
  saveTextProperties: (nodeId: string, text: string, textAlign: 'left' | 'center' | 'right') => void;
  selectedActor: Node<NodeData> | null;
  closeActorPropertiesPanel: () => void;
  saveActorProperties: (nodeId: string, actorText: string, actorColor: string) => void;
}

export function DiagramPropertiesPanels({
  selectedNode,
  closePropertiesPanel,
  saveNodeProperties,
  selectedEdge,
  closeEdgePropertiesPanel,
  saveEdgeProperties,
  selectedGroup,
  closeGroupPropertiesPanel,
  saveGroupProperties,
  selectedText,
  closeTextPropertiesPanel,
  saveTextProperties,
  selectedActor,
  closeActorPropertiesPanel,
  saveActorProperties,
}: DiagramPropertiesPanelsProps) {
  return (
    <>
      {selectedNode && (
        <NodePropertiesPanel
          node={selectedNode}
          onClose={closePropertiesPanel}
          onSave={saveNodeProperties}
        />
      )}

      {selectedGroup && (
        <GroupPropertiesPanel
          node={selectedGroup}
          onClose={closeGroupPropertiesPanel}
          onSave={saveGroupProperties}
        />
      )}

      {selectedText && (
        <TextPropertiesPanel
          node={selectedText}
          onClose={closeTextPropertiesPanel}
          onSave={saveTextProperties}
        />
      )}

      {selectedActor && (
        <ActorPropertiesPanel
          node={selectedActor}
          onClose={closeActorPropertiesPanel}
          onSave={saveActorProperties}
        />
      )}

      <EdgePropertiesPanel
        edge={selectedEdge}
        onClose={closeEdgePropertiesPanel}
        onSave={saveEdgeProperties}
      />
    </>
  );
}
